var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 171,
    viewBox: "0 0 194 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_283",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 194,
    height: 172
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 194,
    height: 171,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_283)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_208_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.815 28.1986H148.899V42.2828H134.815V28.1986ZM134.815 49.3248H148.899V63.409H134.815V49.3248ZM113.689 28.1986H127.773V42.2828H113.689V28.1986ZM113.689 49.3248H127.773V63.409H113.689V49.3248Z",
    fill: "#FDF8FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_208_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.857 77.4933V98.6195H57.3524V42.2829H99.6048V35.2408H57.3524C55.4847 35.2408 53.6935 35.9828 52.3729 37.3034C51.0522 38.6241 50.3103 40.4152 50.3103 42.2829V98.6195C50.3103 100.487 51.0522 102.278 52.3729 103.599C53.6935 104.92 55.4847 105.662 57.3524 105.662H85.5207V119.746H71.4365V126.788H127.773V119.746H113.689V105.662H141.857C143.725 105.662 145.516 104.92 146.837 103.599C148.157 102.278 148.899 100.487 148.899 98.6195V77.4933H141.857ZM106.647 119.746H92.5627V105.662H106.647V119.746Z",
    fill: "#FDF8FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.18 7.3252H180.21V30.3551H157.18V7.3252ZM157.18 41.8701H180.21V64.9H157.18V41.8701ZM122.635 7.3252H145.665V30.3551H122.635V7.3252ZM122.635 41.8701H145.665V64.9H122.635V41.8701Z",
    fill: "#FDF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.695 87.9299V122.475H30.515V30.3551H99.6048V18.8401H30.515C27.461 18.8401 24.5321 20.0533 22.3727 22.2127C20.2132 24.3722 19 27.3011 19 30.3551V122.475C19 125.529 20.2132 128.458 22.3727 130.617C24.5321 132.777 27.461 133.99 30.515 133.99H76.5748V157.02H53.5449V168.535H145.665V157.02H122.635V133.99H168.695C171.749 133.99 174.677 132.777 176.837 130.617C178.996 128.458 180.21 125.529 180.21 122.475V87.9299H168.695ZM111.12 157.02H88.0898V133.99H111.12V157.02Z",
    fill: "#FDF8FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_208_283",
    x: 104.816,
    y: 19.3256,
    width: 52.9565,
    height: 52.9564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.633786
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.666667 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_208_283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26757
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.666667 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_208_283",
    result: "effect2_dropShadow_208_283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.43651
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.666667 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_208_283",
    result: "effect3_dropShadow_208_283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_208_283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_208_283",
    x: 25.4659,
    y: 10.3964,
    width: 148.278,
    height: 141.236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7746
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.666667 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_208_283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5492
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.666667 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_208_283",
    result: "effect2_dropShadow_208_283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.4222
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.666667 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_208_283",
    result: "effect3_dropShadow_208_283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_208_283",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.3d194331739b167239ca708fa7865df1.svg";
export { ForwardRef as ReactComponent };